import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { UserRole } from 'src/app/models/user-role';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  UserRole = UserRole;

  constructor(public authService: AuthService) { }

  ngOnInit() {
  }

}
